import { post, postExFile } from "@utils/httpUtil";
// 视频咨询服务接口（排班/出诊地等走 communityVideoConsult* 路径，与线下面诊接口分离）
const VC = "/c/pc/communityVideoConsult";
const VC_PLAN = `/c/pc/communityVideoConsultSchedulePlan`;
const VC_SCHED = `/c/pc/communityVideoConsultSchedule`;
/** 视频咨询出诊地（与线下面诊 communityOfflineDiagnosisVisitLocation 路径对应分离） */
const VC_VISIT_LOC = "/c/pc/communityVideoConsultVisitLocation";
/** 地区字典等与线下面诊共用 */
export { getDictionaryTree } from "./outpatientServiceNew";
export function communityVideoConsultGetConfig(data, config) {
  return post(`${VC}/getConfig`, data, config);
}
export function communityVideoConsultUpdateConfig(data, config) {
  return post(`${VC}/updateConfig`, data, config);
}
export function communityVideoConsultPageList(data, config) {
  return post(`${VC}/pageList`, data, config);
}
export function batchUpdateVideoConsultStatus(data, config) {
  return post(`${VC}/batchUpdateVideoConsultStatus`, data, config);
}
export function communityVideoConsultExport(data, config) {
  return postExFile(`${VC}/export`, data, config);
}
export function pageSchedulePlan(data, config) {
  return post(`${VC_PLAN}/pageSchedulePlan`, data, config);
}
export function communityVideoConsultSchedulePlanExport(data, config) {
  return postExFile(`${VC_PLAN}/export`, data, config);
}
export function cancelSchedulePlan(data, config) {
  return post(`${VC_PLAN}/cancelSchedulePlan`, data, config);
}
export function createDoctorSchedulePlan(data, config) {
  return post(`${VC_PLAN}/createDoctorSchedulePlan`, data, config);
}
export function createDoctorSchedulePlanCheck(data, config) {
  return post(`${VC_PLAN}/createDoctorSchedulePlan/check`, data, config);
}
export function listScheduleByDoctor(data, config) {
  return post(`${VC_SCHED}/listScheduleByDoctor`, data, config);
}
/** 条件查询视频咨询出诊地列表（与线下面诊 communityOfflineDiagnosisVisitLocation/findVisitLocationListByCondition 对应） */
export function videoConsultFindVisitLocationListByCondition(data, config) {
  return post(`${VC_VISIT_LOC}/findVisitLocationListByCondition`, data, config);
}
export function getSchedulePlanById(data, config) {
  return post(`${VC_PLAN}/getSchedulePlanById`, data, config);
}
export function cancelSchedulePlanDetail(data, config) {
  return post(`${VC_PLAN}/cancelSchedulePlanDetail`, data, config);
}
export function getDoctorSetting(data, config) {
  return post(`${VC_PLAN}/getDoctorSetting`, data, config);
}
/** 排班记录关联的出诊地列表（视频咨询 Plan 独立路径） */
export function getSchedulePlanVisitLocationList(data, config) {
  return post(`${VC_PLAN}/getSchedulePlanVisitLocationList`, data, config);
}
/** 视频咨询出诊地医生设置列表分页（与线下面诊 communityOfflineDiagnosisVisitLocation 分离） */
export function pageDoctorVisitLocationSetting(data, config) {
  return post(`${VC_VISIT_LOC}/pageDoctorVisitLocationSetting`, data, config);
}
/** 设置视频咨询出诊地医生价格 */
export function updateVisitLocationSetting(data, config) {
  return post(`${VC_VISIT_LOC}/updateVisitLocationSetting`, data, config);
}
/** 批量设置视频咨询出诊地医生价格 */
export function batchUpdateVisitLocationSetting(data, config) {
  return post(`${VC_VISIT_LOC}/batchUpdateVisitLocationSetting`, data, config);
}